import React, { useState } from 'react';
import AdminSidebar from './AdminSidebar';

interface AdminLayoutProps {
  children: React.ReactNode;
  language: 'ar' | 'en';
  currentPage?: string;
  onSectionAdd?: (sectionType: string) => void;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ 
  children, 
  language, 
  currentPage = 'dashboard',
  onSectionAdd 
}) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const isRTL = language === 'ar';

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <div className={`${sidebarCollapsed ? 'w-16' : 'w-64'} transition-all duration-300`}>
        <AdminSidebar 
          language={language}
          currentPage={currentPage}
          onSectionAdd={onSectionAdd}
        />
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top Header */}
        <header className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <button
                onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
              
              <h1 className="text-xl font-semibold text-gray-900 ml-4">
                {isRTL ? 'لوحة التحكم' : 'Admin Dashboard'}
              </h1>
            </div>

            <div className="flex items-center space-x-4 rtl:space-x-reverse">
              {/* Language Toggle */}
              <button className="px-3 py-1 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors text-sm">
                {language === 'ar' ? 'English' : 'العربية'}
              </button>

              {/* User Menu */}
              <div className="relative">
                <button className="flex items-center space-x-2 rtl:space-x-reverse p-2 rounded-lg hover:bg-gray-100 transition-colors">
                  <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white text-sm font-semibold">
                    A
                  </div>
                  <span className="text-sm font-medium text-gray-700">
                    {isRTL ? 'المدير' : 'Admin'}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 overflow-auto p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout; 